import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SKIP_PERSON_LOADER_SEARCH_PARAM } from "../../../components/Organismos/Person/AddProfessional";

export type ProfessionalsRouteContext = "staff" | "dataAdmin";

type ProfilePersonSlug = {
  name?: string;
  lastName?: string;
};

export function getProfessionalsRouteContext(
  pathname: string,
): ProfessionalsRouteContext {
  if (pathname.toLowerCase().startsWith("/manage-firm/professionals")) {
    return "dataAdmin";
  }
  return "staff";
}

function buildDataAdminPublicProfilePath(
  profileId: string | number,
  person?: ProfilePersonSlug,
): string {
  const slug = [person?.name, person?.lastName]
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join("-");
  return slug ? `/profile/${slug}/${profileId}` : `/profile/${profileId}`;
}

export function useProfessionalsRoutePaths(firmId: string | undefined) {
  const { pathname } = useLocation();

  return useMemo(() => {
    const context = getProfessionalsRouteContext(pathname);
    const isDataAdminRoute = context === "dataAdmin";

    return {
      context,
      isDataAdminRoute,
      dataAdminReadOnly: isDataAdminRoute,
      editProfessional: (generatedId: string | number) =>
        isDataAdminRoute
          ? `/manage-firm/professionals/edit/${generatedId}?${SKIP_PERSON_LOADER_SEARCH_PARAM}=1`
          : firmId
            ? `/ManageFirm/Professionals/${firmId}/Edit/${generatedId}?${SKIP_PERSON_LOADER_SEARCH_PARAM}=1`
            : "Edit",
      profileAttorney: (
        generatedId: string | number,
        person?: ProfilePersonSlug,
      ) =>
        isDataAdminRoute
          ? buildDataAdminPublicProfilePath(generatedId, person)
          : `/staff/profile/attorney/${generatedId}`,
      logsRelative: isDataAdminRoute ? "logs" : "Logs",
      createRelative: isDataAdminRoute ? "create" : "Create",
    };
  }, [pathname, firmId]);
}
